// extracted by mini-css-extract-plugin
export default {"questionVoteBox":"A2-z","upvote":"B2-z","downvote":"C2-z","numVotes":"D2-z","votesDescription":"E2-z","report":"F2-z","voted":"G2-z","answerVoteBox":"H2-z","justReported":"I2-z"};